import React, { useMemo, useState, useEffect } from "react";
import {
  Box, Grid, Paper, Typography, TextField, InputAdornment, IconButton,
  Button, Radio, RadioGroup, FormControlLabel, MenuItem, Checkbox,
  Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Tooltip,
  CircularProgress,
  Fab,
  Hidden,
  Toolbar,
  AppBar
} from "@material-ui/core";
import {
  Folder as FolderIcon, FolderOpen as FolderOpenIcon,
  InsertDriveFile as FileIcon, Search as SearchIcon,
  ExpandMore as ExpandMoreIcon, ChevronLeft as ChevronLeftIcon,
  Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon,
  Save as SaveIcon, Print as PrintIcon, Undo as UndoIcon,
  ExitToApp as ExitIcon, AccountTree as TreeIcon,
  List as ListIcon, Settings as SettingsIcon, Create as CreateIcon,
  Close as CloseIcon,
  Save,
  Close,
  Print,
  Reply
} from "@material-ui/icons";
import "./ItemGroups.css";
import axios from "axios";
import { insh, sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import toast, { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { stElemnt } from "../../../../St/comps/cStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import { useStylesBA, useStylesCAB, useStylesHed, useStylesSetting } from "../../../../St/comps/UseStyle";
import { useHistory } from "react-router-dom";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { Autocomplete } from "@material-ui/lab";

const EMPTY_GROUP = {
  id: 0,
  name: "",
  nameEN: "",
  color: "-1",
  printer: "",
  printerDef: "",
  group_id: "",
  parent_id: 0,
  acc_branch: null,
  discount: 0,
  amount_disc: 0,
  WithOutDisc: null,
  group_Emps: [],
};
const isRoot = (g) => !g.parent_id || Number(g.parent_id) === 0;

export default function ItemGroups({
  Employees,
  title = "مجموعات الأصناف"
}) {
  const [groups, setGroups] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [expanded, setExpanded] = useState([]);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState("view"); // view | new | edit
  const [form, setForm] = useState({ ...EMPTY_GROUP });
  const [original, setOriginal] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation(["forms", "translation"]);

  const {
    data: printers,
    fetching,
    fetchURL: furl,
  } = useFetchURL({
    ...{
      url: "http://localhost:7000/printers/list",
    },
  });


  const viewHandle = async () => {
    setIsSearch(true)
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `Groups`
    } else {
      Urls = `Groups?db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        setGroups(res.data.map(norm).sort((a, b) => a.id - b.id));
      })
      .catch((err) => {
        setGroups([]);
      });
  };
  useEffect(() => {
    if (!isSearch) {
      viewHandle();
    }
  }, [groups, isSearch]);

  useEffect(() => {
    // if (!isSearch) {
      newMain();
    // }
  }, [groups, isSearch]);

  const norm = (g) => ({
    ...EMPTY_GROUP,
    ...g,
    parent_id: g.parent_id == null || g.parent_id === "" ? 0 : Number(g.parent_id),
    printerDef: printers.find((obj) => obj === g.printer),
    discount: Number(g.discount || 0),
    amount_disc: Number(g.amount_disc || 0)
  });

  const selected = groups.find(g => String(g.id) === String(selectedId)) || null;
  const children = useMemo(
    () => selectedId == null ? [] : groups.filter(g => Number(g.parent_id) === Number(selectedId)),
    [groups, selectedId]
  );
  const editing = mode !== "view";

  const setField = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const chooseGroup = (g) => {
    setSelectedId(g.id);
    setForm(norm(g));
    setOriginal(norm(g));
    setMode("view");
  };

  const toggle = (id) => setExpanded(prev =>
    prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
  );

  const descendantsOf = (id) => {
    const found = new Set();
    const walk = (parent) => groups.filter(g => Number(g.parent_id) === Number(parent)).forEach(g => {
      if (!found.has(g.id)) { found.add(g.id); walk(g.id); }
    });
    walk(id);
    return found;
  };

  const matches = useMemo(() => {
    if (!search.trim()) return null;
    const q = search.trim().toLowerCase();
    const ids = new Set();
    groups.forEach(g => {
      if ([g.name, g.nameEN, String(g.id)].join(" ").toLowerCase().includes(q)) {
        ids.add(g.id);
        let parent = groups.find(x => Number(x.id) === Number(g.parent_id));
        while (parent) {
          ids.add(parent.id);
          parent = groups.find(x => Number(x.id) === Number(parent.parent_id));
        }
      }
    });
    return ids;
  }, [search, groups]);

  const nextCode = () => Math.max(0, ...groups.map(g => Number(g.group_id) || 0)) + 1;
  const nextId = () => Math.max(0, ...groups.map(g => Number(g.id) || 0)) + 1;

  const newMain = () => {
    setSelectedId(null);
    setForm({ ...EMPTY_GROUP, group_id: nextCode(), id: nextId(), parent_id: 0, printer: "" });
    setOriginal(null);
    setSubmitting(false);
    setMode("new");
  };
  const validate = () => {
    if (!String(form.group_id).trim()) return "أدخل كود المجموعة";
    if (!String(form.name).trim()) return "أدخل اسم المجموعة";
    if (Number(form.discount) < 0 || Number(form.discount) > 100) return "نسبة الخصم يجب أن تكون بين 0 و100";
    if (Number(form.amount_disc) < 0) return "قيمة الخصم لا يمكن أن تكون سالبة";
    if (groups.some(g => String(g.group_id) === String(form.group_id) && String(g.id) !== String(form.id))) return "كود المجموعة مستخدم مسبقاً";
    if (form.parent_id && !groups.some(g => String(g.id) === String(form.parent_id))) return "المجموعة الأب غير موجودة";
    if (mode === "edit" && form.parent_id && descendantsOf(form.id).has(Number(form.parent_id))) return "لا يمكن نقل المجموعة إلى أحد أبنائها";
    if (mode === "edit" && Number(form.parent_id) === Number(form.id)) return "لا يمكن أن تكون المجموعة أباً لنفسها";
    return null;
  };

  const timer = React.useRef();
  const [success, setSuccess] = useState(insh.LoadAndSucc);

  const ButtonSuccess = (prop, timr, data) => {
    timer.current = window.setTimeout(() => {
      setSuccess({ ...success, [prop]: true });
      newMain();
      setSubmitting(false);
    }, 1000);
  };
  const applyDiscGroup = async (data) => {
    await axios
      .post(uri + "Groups/applyDisc", form)
      .then((res) => {
        toast.success(t("discount-applied-to-items"));
      })
      .catch((err) => {
        toast.error(t("apply-failed"));
        console.log(err);
      });
  };

  const save = async () => {
    const error = validate();
    if (error) { setNotice(error); return; }
    setBusy(true);
    try {
      const payload = {
        ...form,
        group_id: Number(form.group_id),
        parent_id: Number(form.parent_id || 0),
        discount: Number(form.discount || 0),
        amount_disc: Number(form.amount_disc || 0),
        WithOutDisc: form.WithOutDisc ? 1 : 0,
        printer: form.printerDef ?? "",
        branch: sto.branchi,
        color: form.color ?? -1,
        db_name: sto?.db_name,
      };

      setSubmitting(true);
      mode === "new" ? axios
        .post(uri + "Groups", payload)
        .then((res) => {
          const allgroups = [...groups, res?.data];
          setGroups(allgroups.map(norm).sort((a, b) => a.id - b.id));
          ButtonSuccess("save", 500, res?.data);
          toast.success(t("added-success"));
          setNotice("تم حفظ البيانات بنجاح");
        })
        .catch((res) => {
          ButtonSuccess("save", 1000, res?.data);
          toast.error(t("add-process-error"));
        })
        :
        axios
          .put(uri + "Groups", payload)
          .then((res) => {
            let newData = groups.filter(a => String(a.id) !== String(form.id));
            const allgroups = [...newData, res?.data];
            setGroups(allgroups.map(norm).sort((a, b) => a.id - b.id));
            ButtonSuccess("update", 1000, res?.data);
            toast.success(t("edited-success"));
            setNotice(t("edited-success"));
          })
          .catch((res) => {
            ButtonSuccess("update", 1000, res?.data);
            toast.error(t("update-failed"));
            setNotice(t("update-failed"));
          });
    } catch (e) {
      setNotice(e?.response?.data?.message || e.message || "تعذر حفظ البيانات");
    } finally { setBusy(false); }
  };

  const remove = async () => {
    if (!selected) return;
    if (groups.some(g => Number(g.parent_id) === Number(selected.id))) {
      setDeleteOpen(false);
      setNotice("لا يمكن حذف المجموعة قبل حذف مجموعاتها الفرعية أو نقلها");
      return;
    }
    setBusy(true);
    try {

      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `Groups?id=${form.id}`
      } else {
        Urls = `Groups?id=${form.id}&&db_name=${sto?.db_name}`
      }

      setSubmitting(true);
      await axios.delete(uri + Urls).then(res => {
        let newData = groups.filter(a => String(a.id) !== String(form.id));
        setGroups(newData.map(norm).sort((a, b) => a.id - b.id));
        newMain();
        setSubmitting(false);
        toast.success("The Account Deleted");
        setNotice("تم حذف المجموعة");
      }).catch(err => {
        ButtonSuccess("delete", false);
        toast.error("not delete ")
      });
    } catch (e) {
      setNotice(e?.response?.data?.message || "تعذر حذف المجموعة");
    } finally { setBusy(false); }
  };

  const treeRows = (parentId = 0, depth = 0) => groups
    .filter(g => isRoot(g) ? parentId === 0 : Number(g.parent_id) === Number(parentId))
    .filter(g => !matches || matches.has(g.id))
    .map(g => {
      const hasKids = groups.some(x => Number(x.parent_id) === Number(g.id));
      const open = expanded.includes(g.id) || Boolean(matches);
      const active = String(selectedId) === String(g.id);
      return (
        <React.Fragment key={g.id}>
          <div
            className={`ig-tree-row ${active ? "selected" : ""}`}
            style={{ paddingRight: 8 + depth * 20 }}
            onClick={() => chooseGroup(g)}
            title={g.name}
          >
            <IconButton
              className="ig-tree-toggle"
              size="small"
              onClick={(e) => { e.stopPropagation(); toggle(g.id); }}
            >
              {hasKids ? (open ? <ExpandMoreIcon /> : <ChevronLeftIcon />) : <span className="ig-no-toggle" />}
            </IconButton>
            {hasKids ? (open ? <FolderOpenIcon className="ig-folder" /> : <FolderIcon className="ig-folder" />) : <FileIcon className="ig-file" />}
            <span className="ig-tree-name">{g.name}</span>
          </div>
          {hasKids && open && <div className="ig-tree-children">{treeRows(g.id, depth + 1)}</div>}
        </React.Fragment>
      );
    });

  const parentOptions = groups.filter(g =>
    String(g.id) !== String(form.id) &&
    !(mode === "edit" && descendantsOf(form.id).has(Number(g.id)))
  );

  const fieldDisabled = false;
  const [style, setStyle] = useState(inshst.bascData.all);
  const clashd = useStylesHed();
  const clasBA = useStylesBA();
  const clasCAB = useStylesCAB();
  let his = useHistory();
  const classesStt = useStylesSetting();

  const backHome = () => {
    his.push({ pathname: "/" }); /*console.log('stooping')*/
  };

  const back = () => his.goBack();

  const onChange = (e, { name, value }) => {
    setForm({ ...form, [name]: value });
  };

  return (
    <Box className="ig-page" dir="rtl">
      <header className="ig-page-heading">
        <div className="ig-heading-main">
          <FolderIcon />
          <Typography variant="h6">{title}</Typography>
        </div>
        <Typography className="ig-subtitle">إدارة وتنظيم المجموعات الرئيسية والفرعية</Typography>
      </header>
      <div dir="rtl">
        <Grid container spacing={1.5} className="ig-content" >
          <Grid item xs={12} md={8}>
            <Paper elevation={0} className="ig-details-card">
              <div className="ig-card-bar ig-details-bar">
                <div><CreateIcon /><span>بيانات المجموعة</span>
                </div>
              </div>

              <Grid container spacing={1.2} className="ig-fields">
                <Grid item xs={12} sm={5}>
                  <label className="ig-label">كود المجموعة</label>
                  <TextField fullWidth size="small" variant="outlined"
                    InputProps={{ readOnly: true }}
                    value={form.group_id ?? ""} disabled={fieldDisabled}
                    onChange={e => setField("group_id", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={7}>
                  <label className="ig-label">اسم المجموعة</label>
                  <TextField fullWidth size="small" variant="outlined"
                    value={form.name || ""} disabled={fieldDisabled}
                    onChange={e => setField("name", e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <label className="ig-label">اسم المجموعة (EN)</label>
                  <TextField fullWidth size="small" variant="outlined"
                    value={form.nameEN || ""}
                    disabled={fieldDisabled} dir="ltr"
                    onChange={e => setField("nameEN", e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={7}>
                  <div className="ig-type-row">
                    <RadioGroup row value={form.parent_id ? "sub" : "main"}
                      onChange={e => setField("parent_id", e.target.value === "main" ? 0 : (form?.id || ""))}
                    >
                      <FormControlLabel value="main" control={<Radio color="secondary" disabled={fieldDisabled} />} label="رئيسية" />
                      <FormControlLabel value="sub" control={<Radio color="secondary" disabled={fieldDisabled} />} label="فرعية" />
                    </RadioGroup>
                  </div>
                  <label className="ig-label">المجموعة الأب</label>
                  <TextField select fullWidth size="small" variant="outlined"
                    value={form.parent_id || ""} disabled={fieldDisabled || !form.parent_id}
                    onChange={e => setField("parent_id", e.target.value || 0)}
                    SelectProps={{ displayEmpty: true }}>
                    <MenuItem value=""><em>--- اختر المجموعة الأب ---</em></MenuItem>
                    {parentOptions.map(g => <MenuItem key={g.id} value={g.id}>{g.name} ({g.group_id})</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="ig-label">لون المجموعة</label>
                  <div className="ig-color-control">
                    <input type="color" disabled={fieldDisabled} value={/^#[0-9a-f]{6}$/i.test(form.color) ? form.color : "#b52d4a"}
                      onChange={e => setField("color", e.target.value)} />
                    <TextField fullWidth size="small" variant="outlined" value={form.color || "-1"} disabled={fieldDisabled}
                      onChange={e => setField("color", e.target.value)} />
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="ig-label">الطابعة</label>
                  <TextField select fullWidth size="small" variant="outlined"
                    value={form.printerDef || ""}
                    disabled={fieldDisabled}
                    onChange={e => setField("printerDef", e.target.value)}>
                    {printers.map(p => <MenuItem key={p}
                      value={p}>{p}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="ig-label">{t("hide-from-employee")}</label>
                  <Autocomplete fullWidth
                    multiple
                    value={form?.group_Emps}
                    onChange={(event, newValue) => {
                      const index = form?.group_Emps?.findIndex(
                        (x) => x.name == event.target.textContent
                      );
                      if (index == -1)
                        onChange(null, { name: "group_Emps", value: newValue });
                    }}
                    id="controllable-states-dem"
                    size="small"
                    options={Employees}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.name
                    }
                    style={{ direction: "ltr" }}
                    disableClearable
                    renderInput={(params) => (
                      <TextField
                        id="valuePricePay"
                        {...params}
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>


            <Paper elevation={0} className="ig-discount-card">
              <div className="ig-discount-heading"><SettingsIcon /><b>إعدادات الخصومات</b></div>
              <Grid container spacing={2} alignItems="center" className="ig-discount-fields">
                <Grid item xs={12} sm={4}>
                  <label className="ig-label">نسبة الخصم %</label>
                  <TextField type="number"
                    fullWidth
                    size="small" variant="outlined"
                    value={form.discount ?? 0}
                    disabled={Number(form?.amount_disc) > 0}
                    onChange={e => setField("discount", e.target.value)}
                    inputProps={{ min: 0, max: 100 }} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="ig-label">قيمة الخصم</label>
                  <TextField type="number"
                    fullWidth size="small"
                    variant="outlined"
                    value={form.amount_disc ?? 0}
                    disabled={Number(form?.discount) > 0}
                    onChange={e => setField("amount_disc", e.target.value)} inputProps={{ min: 0 }} />
                </Grid>
                <Grid item xs={12} sm={4} >
                  <Button
                    variant="contained"
                    className={classesStt.btn}
                    color="red"
                    fontSize="small"
                    onClick={() => {
                      applyDiscGroup();
                    }}
                    disabled={submitting}
                  >
                    {submitting
                      ? t("applying-discount")
                      : t("apply-discount-to-items")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>

            <Paper elevation={0} className="ig-table-card">
              <div className="ig-card-bar ig-table-bar">
                <div><ListIcon /><span>المجموعات التابعة</span></div>
                {/* <Button className="ig-add-child" startIcon={<AddIcon />} onClick={newChild} disabled={!selected || editing}>
                إضافة مجموعة فرعية
              </Button> */}
              </div>
              <div className="ig-table-wrap">
                <table className="ig-table">
                  <thead><tr><th>كود المجموعة</th><th>اسم المجموعة</th><th>نوع المجموعة</th><th>الإجراء</th></tr></thead>
                  <tbody>
                    {children.map(g => (
                      <tr key={g.id} onClick={() => chooseGroup(g)} className={String(selectedId) === String(g.id) ? "active-row" : ""}>
                        <td>{g.id}</td>
                        <td>{g.name}</td>
                        <td><span className="ig-sub-badge">فرعية</span></td>
                        <td className="ig-actions">
                          <Tooltip title="تعديل"><IconButton onClick={e => { e.stopPropagation(); chooseGroup(g); setMode("edit"); }}><EditIcon /></IconButton></Tooltip>
                          <Tooltip title="حذف"><IconButton onClick={e => { e.stopPropagation(); chooseGroup(g); setDeleteOpen(true); }}><DeleteIcon /></IconButton></Tooltip>
                        </td>
                      </tr>
                    ))}
                    {!children.length && <tr><td colSpan="4" className="ig-empty-row">حدد مجموعة رئيسية لعرض مجموعاتها التابعة</td></tr>}
                  </tbody>
                </table>
              </div>
            </Paper>

          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={0} className="ig-tree-card">
              <div className="ig-card-bar">
                <div><TreeIcon /><span>شجرة المجموعات</span></div>
                <Tooltip title="توسيع جميع المجموعات">
                  <IconButton onClick={() => setExpanded(groups.map(g => g.id))}><ExpandMoreIcon /></IconButton>
                </Tooltip>
              </div>
              <TextField
                className="ig-search"
                fullWidth
                variant="outlined"
                size="small"
                placeholder="بحث عن مجموعة ..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    {search ? <IconButton size="small" onClick={() => setSearch("")}><CloseIcon /></IconButton> : <SearchIcon />}
                  </InputAdornment>
                }}
              />
              <div className="ig-tree-scroll">
                <div className="ig-tree-root" onClick={() => { setSelectedId(null); setForm({ ...EMPTY_GROUP }); }}>
                  <ExpandMoreIcon /><FolderIcon /><b>مجموعات الأصناف</b>
                </div>
                {treeRows()}
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <AppBar
        position="fixed"
        color="primary"
        style={{
          ...style.bgImg,
          ...stElemnt.all.appBarBA,
          direction: "ltr",
        }}
      >
        <Toolbar className={clasBA.ToolbarBA} variant="dense">
          <Hidden smUp={["sm"]}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={() => backHome()}
            >
              <CloseIcon />
            </IconButton>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={() => back()}
            >
              <Reply />
            </IconButton>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={""}
            >
              <Print />
            </IconButton>
          </Hidden>

          <Hidden only={["xs"]}>
            <Button
              style={{ color: "#fff" }}
              onClick={() => backHome()}
              startIcon={<Close />}
            >
              {t("exit")}
            </Button>
            <Button
              style={{ color: "#fff" }}
              onClick={() => back()}
              startIcon={<Reply />}
            >
              {t("back")}
            </Button>
          </Hidden>

          <div className={clasBA.growBA} />

          <Hidden smUp={["sm"]}>
            {/* ico left  */}
            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                onClick={() => save()}
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
              >
                {<Save />}
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>

            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                onClick={() => newMain()}
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
              >
                {<AddIcon />}
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>
          </Hidden>
          {mode == "view" ? (
            <div className={clasCAB.wrapperCAB}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<DeleteIcon />}
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                disabled={submitting}
                onClick={(e) => remove()}
              >
                {t("delete")}
              </Button>
              {submitting && (
                <CircularProgress
                  size={24}
                  className={clasCAB.buttonProgressCAB}
                />
              )}
            </div>
          ) : null}

          <Hidden only={["xs"]}>
            <div className={clasCAB.wrapperCAB}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                disabled={submitting}
                onClick={() => save()}
                startIcon={<SaveIcon />}
              >
                {" "}
                {mode == "new" ? t("save") : t("save-update")}{" "}
              </Button>
              {submitting && (
                <CircularProgress
                  size={24}
                  className={clasCAB.buttonProgressCAB}
                />
              )}
            </div>

            <div className={clasCAB.wrapperCAB}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                onClick={() => newMain()}
                startIcon={<AddIcon />}
              >
                {" "}
                {t("new")}{" "}
              </Button>
            </div>
          </Hidden>
        </Toolbar>
      </AppBar>

      <Toaster
        position="top_center"
        reverseOrder={false}
        gutter={8}
        containerStyle={{
          zIndex: 999999,
        }}
        toastOptions={{
          duration: 3000,
          style: {
            fontFamily: "Arial",
            fontSize: "15px",
            fontWeight: "bold",
            direction: "rtl",
            zIndex: 999999
          },
        }} />
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>تأكيد حذف المجموعة</DialogTitle>
        <DialogContent>هل تريد حذف المجموعة <b>{selected?.name}</b>؟</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>إلغاء</Button>
          <Button color="secondary" variant="contained" onClick={remove} disabled={busy}>حذف</Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={Boolean(notice)} autoHideDuration={3500} onClose={() => setNotice("")}
        message={notice} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} />
    </Box>
  );
}
